import React from "react";
import PropTypes from "prop-types";
import {useTranslation} from "react-i18next";

const STATUS_STYLES = {
    draft: {
        labelKey: "app.documents.status.draft",
        defaultLabel: "Bozza",
        className: "bg-slate-100 text-slate-800",
    },
    pending: {
        labelKey: "app.documents.status.pending",
        defaultLabel: "In attesa",
        className: "bg-amber-100 text-amber-800",
    },
    review: {
        labelKey: "app.documents.status.review",
        defaultLabel: "In revisione",
        className: "bg-sky-100 text-sky-800",
    },
    confirmed: {
        labelKey: "app.documents.status.confirmed",
        defaultLabel: "Confermato",
        className: "bg-green-100 text-green-800",
    },
    canceled: {
        labelKey: "app.documents.status.canceled",
        defaultLabel: "Annullato",
        className: "bg-rose-100 text-rose-800",
    },
};

const buildStatusConfig = (status, t) => {
    if (!status) {
        return null;
    }

    const normalized = String(status).toLowerCase();
    const config = STATUS_STYLES[normalized] ?? {
        labelKey: "app.documents.status.generic",
        defaultLabel: status,
        className: "bg-blue-100 text-blue-800",
    };

    return {
        className: config.className,
        label: t(config.labelKey, {defaultValue: config.defaultLabel}),
    };
};

const DocumentStatusBadge = ({status}) => {
    const {t} = useTranslation();
    const config = buildStatusConfig(status, t);

    if (!config) {
        return null;
    }

    return (
        <span className={`inline-flex items-center rounded-full px-2.5 py-1 text-xs font-medium ${config.className}`}>
            {config.label}
        </span>
    );
};

DocumentStatusBadge.propTypes = {
    status: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number,
    ]),
};

DocumentStatusBadge.defaultProps = {
    status: null,
};

export default DocumentStatusBadge;
